"use strict";

exports.__esModule = true;
var _TimePeriodController = require("./TimePeriodController");
Object.keys(_TimePeriodController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TimePeriodController[key]) return;
  exports[key] = _TimePeriodController[key];
});